import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { EmptyStateComponent } from './empty-state.component';
import { PipesModule } from 'shared/pipes';

@NgModule({
    imports: [CommonModule, PipesModule, TranslateModule],
    declarations: [EmptyStateComponent],
    exports: [EmptyStateComponent]
})
export class EmptyStateModule {}
